module.exports = __webpack_public_path__ + "img/769-0cedc6.png";